import type { BrandingContextView, TenantResolutionMode } from '../domain/branding-context'

function modeFromConfig(value: unknown): TenantResolutionMode {
  return value === 'domain' || value === 'header' || value === 'fixed' ? value : 'fixed'
}

export function resolveBrandingContext(): BrandingContextView {
  const config = useRuntimeConfig().public
  const mode = modeFromConfig(config.tenantMode)
  const host = import.meta.client ? window.location.hostname : ''
  const trustedHeaders = (import.meta.server
    ? useRequestHeaders([String(config.tenantIdHeader || 'x-tenant-id'), String(config.tenantDomainHeader || 'x-tenant-domain'), 'host'])
    : {}) as Record<string, string | undefined>
  const headerTenantId = trustedHeaders[String(config.tenantIdHeader || 'x-tenant-id').toLowerCase()]
  const headerTenantDomain = trustedHeaders[String(config.tenantDomainHeader || 'x-tenant-domain').toLowerCase()] || trustedHeaders.host
  const tenantId = mode === 'fixed' ? String(config.tenantId || '') : String(headerTenantId || config.tenantId || '')
  const tenantDomain = String(config.tenantDomain || headerTenantDomain || (mode === 'domain' ? host : ''))

  return {
    mode,
    ...(tenantId ? { tenantId } : {}),
    ...(tenantDomain ? { tenantDomain } : {}),
    brandName: String(config.brandName || 'Tiquete360'),
    accentColor: '#00ccb8'
  }
}
